import { componentFactory } from '@fusioncharts/core/src/lib';
import LegendClass from '../_internal/components/legend/discrete';

export default function (chart) {
  let legend,
    count = chart.config.showLegend ? 1 : 0;

  componentFactory(chart, LegendClass, 'legend', count, [{}]);

  legend = chart.getChildren('legend');
  if (legend && legend[0] && !legend[0].getState('removed')) {
    chart.addToEnv('legend', legend[0]);
  } else {
    chart.deleteFromEnv('legend');
  }
}
